import {Pagination} from '../../interfaces/Pagination';
import {PaginationParams} from '../../interfaces/PaginationParams';
import {ObjectMapService} from '../object-map/object-map.service';
import {Observable} from 'rxjs/Observable';

/**
 *
 */
export abstract class PaginationAbstractService<Resource, P> {

  protected _pagination: Pagination<Resource>;
  protected _params: P = <P><Object>{limit: 10, page: 1};
  protected _loading = false;
  private _storageKey: string;

  protected _shouldCache = true;
  /**
   *
   * @param {ObjectMapService} _objMapService
   * @param {string} storageKey
   */
  constructor(private _objMapService: ObjectMapService, storageKey: string) {
    this._storageKey = storageKey;
    this.loadParamsFromStorage();
  }

  /**
   * Get pagination parameters
   * @returns {PaginationParams | Params}
   */
  public get params(): P {
    return this._params;
  }

  /**
   * Determine if the resource is currently loading
   * @returns {boolean}
   */
  public get loading() {
    return this._loading;
  }

  protected setParam(key: string, value: any) {
    if (value !== undefined || value === null)
      return;
    this._params[key] = value;
    this.saveParamsToStorage();
  }

  public clearCache() {
    this._pagination = null;
  }

  /**
   * Cleans the parameters from undefined or null values.
   * @returns {{}}
   */
  protected cleanParams(): P {
    const newParams = {};
    for (const key in this._params)
      if (this._params.hasOwnProperty(key) && this._params[key] !== undefined && this.params[key] !== null)
        newParams[<string>key] = this._params[key];
    return <P> newParams
  }

  /**
   * Gets the pagination object from the server
   * @param {PaginationParams | Params} params
   * @returns {Observable<Pagination<Resource>>}
   */
  public getPagination(params: P) {
    params = <P>{...<Object> this._params, ...<Object> params};
    if (this._objMapService.shallowCompare(this._params, params) &&
      this._objMapService.shallowCompare(params, this._params)
      && this._pagination != null)
      return Observable.of(this._pagination);
    else
      return this.preparePrefetch(params);
  }

  /**
   * Prepares and executes the pre-fetching of the data.
   * @param {Params} params
   */
  protected preparePrefetch(params: P) {
    this._loading = true;
    this._params = params;
    this.saveParamsToStorage();
    return this.prefetch().do((pagination) => {
      this._pagination = pagination;
      this._loading = false
    });
  }

  /**
   * Retrieve the data
   * @returns The observable for the pagination resource
   */
  protected abstract prefetch(): Observable<Pagination<Resource>>;

  protected loadParamsFromStorage() {
    if (this._shouldCache)
      this._params = <P>{...<Object>this.params, ...JSON.parse(localStorage.getItem(this._storageKey))};
    return this._params;
  }

  /**
   * Saves the pagination parameters to local-storage
   */
  protected saveParamsToStorage() {
    if (this._shouldCache)
      localStorage.setItem(this._storageKey, JSON.stringify(this._params));
  }

}




// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/utilities/services/pagination-abstract/pagination-abstract.service.ts